import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "src/context";
import AuthService from "src/function/auth/AuthService";
import doneNotify from "src/notifications/doneNotify";
import errorNotify from "src/notifications/errorNotify";


const useRegister = () => {
  const { setIsAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const registerUser = async (email: string, password: string, telegramId: number) => {
    try {
      const registerUserRequest = await AuthService.fetchRegisterUser(email, password, telegramId);

      if (registerUserRequest.status === "success") {
          localStorage.setItem('auth', 'true')
          setIsAuth(true);
          navigate('/cabinet');
          doneNotify('Вы успешно зарегестрировались');
      } else {
        if (!registerUserRequest.error) throw new Error('error register user');
        throw new Error(`error register user ==> ${registerUserRequest.error}`);
      }
    } catch (error) {
      console.error('Невідома помилка:', error);
      errorNotify('Возникла непредвиденная ошибка.');
    };
  };

  return [registerUser]
}

export default useRegister